import Cropping from './Cropping';

export default Cropping;
